
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 8h-5a1 1 0 110-2h5a1 1 0 110 2z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M16 9a8.5 8.5 0 108.5 8.5A8.51 8.51 0 0016 9zm2.8 10.6a.999.999 0 01-1.4.2l-2-1.5a.999.999 0 01-.4-.8V15a1 1 0 012 0v2l1.6 1.2a1 1 0 01.2 1.4z","fill":"#fff"}})])
          )
        }
      }
    